export function validacionDisponibilidad(pop) {
    let totalApartados = 0;

    if (pop.apartados) {
        totalApartados = Object.keys(pop.apartados).reduce(
            (suma, indice) => suma + pop.apartados[indice].cantidadApartada,
            0
        );
    }

    return [
        pop.cantidadDisponible - totalApartados,
        totalApartados,
    ];
}
